import { chooseSurfaces, type Surface } from './registry.js';

/**
 * The route registry. Every directory that owns a surface exports one from its own
 * `surface.tsx`; this glob picks it up at build time. Adding a surface never means
 * editing a shared router file, and registering a route a placeholder holds simply
 * takes it over.
 */
const modules = import.meta.glob<{ surface?: Surface; surfaces?: readonly Surface[] }>('/src/**/surface.tsx', {
  eager: true,
});

function declared(): readonly Surface[] {
  const found: Surface[] = [];
  for (const module of Object.values(modules)) {
    if (module.surface !== undefined) found.push(module.surface);
    if (module.surfaces !== undefined) found.push(...module.surfaces);
  }
  return found;
}

export const registeredSurfaces: readonly Surface[] = chooseSurfaces(declared());
